import { useState } from 'react'

import filter from "../assets/filter.png"
import star from "../assets/Polygon.png"
import BuyButton from '../components/Button'

import { AiOutlineStar, AiFillStar } from "react-icons/ai"

import TooltipComponent from '../components/tooltip'

import UserModal from '../components/Modal'
import MobSidebar from '../components/MobSidebar'

import { useMediaQuery } from 'react-responsive'
import BecomeAsellerBtn from '../components/BecomeAsellerBtn'
import defaultUser from "../assets/defaultUser.png";



function Marketplace() {

    const [modalItem, setModalItem] = useState("");

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = (modalItemValue) => { setShow(true); setModalItem(modalItemValue) };

    const isMobile = useMediaQuery({ query: '(max-width: 992px)' })


    const [cities, setCities] = useState([
        { "city": "London" },
        { "city": "Birmingham" },
        { "city": "Manchester" },
        { "city": "Leeds" },
        { "city": "Liverpool" },
        { "city": "Newcastle" },
        { "city": "Sheffield" },
        { "city": "Bristol" },
        { "city": "Nottingham" },
        { "city": "Southampton" },
        { "city": "Leicester" },
        { "city": "Edinburgh" },
        { "city": "Glasgow" },
        { "city": "Cardiff" },
        { "city": "Oxford" },
        { "city": "Cambridge" },
        { "city": "York" },
        { "city": "Bath" },
        { "city": "Brighton" },
        { "city": "Norwich" }

    ])



    return (
        <>
            <section className='marketplace_sec'>
                <div className="container">
                    <div className="row">
                        <div className={`col-lg-3 col-md-12 ${isMobile ? "d-none" : "d-block"}`}>
                            {/* original sidebar */}
                            <div className="sidebar">
                                <div className="head_cont d-flex jc-between ai-center">
                                    <div className='d-flex ai-center'>
                                        <img src={filter} alt="image" className='img-fluid' />
                                        <h5 className='mx-2'>Filters</h5>
                                    </div>
                                </div>
                                <div className="form_cont">
                                    <div>
                                        <label for="customRange1" className="form-label">Price</label>
                                        {/* <Range /> */}
                                        {/* input range */}
                                        <div className="row">
                                            <div className="col-10">
                                                <input type="range" defaultValue="50" className="form-range" min="10" max="100" id="customRange1" />
                                            </div>
                                            <div className="col-2">
                                                50
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <label for="customRange1" className="form-label" >Quantity (kwh)</label>
                                        <div className="row">
                                            <div className="col-10">
                                                <input type="range" defaultValue="80" min="10" max="150" className="form-range" id="customRange1" />
                                            </div>
                                            <div className="col-2">
                                                80
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
                                        <label className="form-check-label" for="flexCheckChecked">
                                            Favourite Energy Producer
                                        </label>
                                    </div>

                                    <label className="form-check-label mt-4">Location</label>
                                    <select className="form-select" aria-label="Default select example">
                                        <option disabled selected>Select Location</option>
                                        {
                                            cities.map((item, i) => (
                                                <option value={item?.city}>{item?.city}</option>
                                            ))
                                        }
                                    </select>

                                    <label className="form-check-label mt-4">Green?</label>
                                    <select className="form-select" aria-label="Default select example">
                                        <option selected value="all">All</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>


                                    <div className="mt-3">
                                        <button type="button" class="btn btn_view btn btn-primary" onClick={() => window.location.reload()}>Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9 col-md-12">
                            <div className="right_cont">
                                <p>Welcome to the WattShare Marketplace: Shaping the Future of Energy!</p>
                                <p>
                                    Embrace a realm of clean, affordable, and sustainable energy solutions designed just for you.
                                    The WattShare Marketplace brings together a variety of energy producers, ensuring you find the
                                    perfect fit for your energy demands. Our platform streamlines the process of purchasing electricty.
                                    whether you prioritize green energy, cost efficiency, or dependable providers.
                                </p>
                                <p>
                                    Take charge of your energy assets and experience the future of P2P energy trading.
                                    Be a part of the revolution today!
                                </p>
                                <div className='market_filter_btn mt-5 d-flex jc-between ai-center'>
                                    <div>
                                        <h3>Marketplace</h3>
                                    </div>
                                    <div className="button become-a-seller-btn d-flex ai-center">
                                        <BecomeAsellerBtn />
                                        <MobSidebar>
                                            <div className="sidebar">
                                                <div className="head_cont d-flex jc-between ai-center">
                                                    <div className='d-flex ai-center'>
                                                        <img src={filter} alt="image" className='img-fluid' />
                                                        <h5 className='mx-2'>Filters</h5>
                                                    </div>
                                                </div>
                                                <div className="form_cont">
                                                    <div>
                                                        <label for="customRange1" className="form-label">Price</label>
                                                        {/* <Range /> */}
                                                        {/* input range */}
                                                        <div className="row">
                                                            <div className="col-10">
                                                                <input type="range" className="form-range" min="10" max="100" defaultValue="50" id="customRange1" />
                                                            </div>
                                                            <div className="col-2">
                                                                50
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label for="customRange1" className="form-label" >Quantity (kwh)</label>
                                                        <div className="row">
                                                            <div className="col-10">
                                                                <input type="range" min="10" max="150" defaultValue="80" className="form-range" id="customRange1" />
                                                            </div>
                                                            <div className="col-2">
                                                                80
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
                                                        <label className="form-check-label" for="flexCheckChecked">
                                                            Favourite Energy Producer
                                                        </label>
                                                    </div>

                                                    <label className="form-check-label mt-4">Location</label>
                                                    <select className="form-select" aria-label="Default select example">
                                                        <option disabled selected>Select Location</option>
                                                        {
                                                            cities.map((item, i) => (
                                                                <option value={item?.city}>{item?.city}</option>
                                                            ))
                                                        }
                                                    </select>

                                                    <label className="form-check-label mt-4">Green?</label>
                                                    <select className="form-select" aria-label="Default select example">
                                                        <option selected value="all">All</option>
                                                        <option value="true">Yes</option>
                                                        <option value="false">No</option>
                                                    </select>


                                                    <div className="mt-3">
                                                        <button type="button" class="btn btn_view btn btn-primary" onClick={() => window.location.reload()}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </MobSidebar>
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className="table table-striped mt-5 text-center">
                                        <thead>
                                            <tr>
                                                <th scope="col">Advertisers</th>
                                                <th scope="col">Price</th>
                                                <th scope="col">Limit/Available</th>
                                                <th scope="col">Is Green</th>
                                                <th scope="col">Details</th>
                                                <th scope="col">
                                                    <div className="form-inline">
                                                        <input type="search" className='form-control search' placeholder='Search here' aria-label='Search' />
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th className='d-flex' scope="row" style={{ textAlign: "start", alignItems: "center" }}>
                                                    <div className='image'>
                                                        <img src={star} alt="image" className='img-fluid star' />
                                                        <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                    </div>
                                                    <div className='mx-3'>
                                                        User 1 <br />
                                                        <small>100 orders</small>
                                                    </div>
                                                </th>
                                                <td>
                                                    <span>500 Matic per kwh</span> <br />
                                                    <small>(2.5 USD)</small>
                                                </td>
                                                <td>50 kwh</td>
                                                <td>Yes</td>
                                                <td>
                                                    <UserModal btnText="View" id={`View`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow} >
                                                        <div className='d-flex jc-between ai-center modal_header'>
                                                            <div className='d-flex ai-center'>
                                                                <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                                <div className='mx-3'>
                                                                    <h5>User 1</h5>
                                                                    <small>100 orders</small>
                                                                </div>
                                                            </div>

                                                            <div className='text-center'>
                                                                <TooltipComponent className="" placement="bottom" tooltipText="Remove from Favourite">
                                                                    <span>
                                                                        <AiFillStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                                    </span>
                                                                </TooltipComponent>
                                                            </div>
                                                        </div>
                                                        <div className='mb-4'>
                                                            <p>Price</p>
                                                            <h6>500 Matic per kwh</h6>
                                                            <small>(2.5 USD)</small>
                                                        </div>
                                                        <div className='mb-4'>
                                                            <p>Available</p>
                                                            <h6>100 kwh</h6>
                                                        </div>
                                                        <div className='mb-4'>
                                                            <small>Other details will add according to system and it's data</small>
                                                        </div>
                                                        <div>
                                                            <h6>Terms and conditions</h6>
                                                            <small>No third-party payment. Thank you</small>
                                                        </div>
                                                    </UserModal>
                                                </td>
                                                <td>
                                                    <BuyButton btnText="Buy" />
                                                </td>
                                            </tr>

                                            <tr>
                                                <th className='d-flex' scope="row" style={{ textAlign: "start", alignItems: "center" }}>
                                                    <div className='image'>
                                                        <img src={star} alt="image" className='img-fluid star' />
                                                        <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                    </div>
                                                    <div className='mx-3'>
                                                        User 2 <br />
                                                        <small>200 orders</small>
                                                    </div>
                                                </th>
                                                <td>
                                                    <span>300 Matic per kwh</span> <br />
                                                    <small>(2.5 USD)</small>
                                                </td>
                                                <td>40 kwh</td>
                                                <td>No</td>
                                                <td>
                                                    <UserModal btnText="View" id={`View`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow} >
                                                        <div className='d-flex jc-between ai-center modal_header'>
                                                            <div className='d-flex ai-center'>
                                                                <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                                <div className='mx-3'>
                                                                    <h5>User 2</h5>
                                                                    <small>200 orders</small>
                                                                </div>
                                                            </div>

                                                            <div className='text-center'>
                                                                <TooltipComponent className="" placement="bottom" tooltipText="Add to Favourite">
                                                                    <span>
                                                                        <AiOutlineStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                                    </span>
                                                                </TooltipComponent>
                                                            </div>
                                                        </div>
                                                        <div className='mb-4'>
                                                            <p>Price</p>
                                                            <h6>300 Matic per kwh</h6>
                                                            <small>(2.5 USD)</small>
                                                        </div>
                                                        <div className='mb-4'>
                                                            <p>Available</p>
                                                            <h6>500 kwh</h6>
                                                        </div>
                                                        <div className='mb-4'>
                                                            <small>Other details will add according to system and it's data</small>
                                                        </div>
                                                        <div>
                                                            <h6>Terms and conditions</h6>
                                                            <small>No third-party payment. Thank you</small>
                                                        </div>
                                                    </UserModal>
                                                </td>
                                                <td>
                                                    <BuyButton btnText="Buy" />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>

                                <h3 className='mt-5' style={{ color: "#413543", fontSize: "24px" }}>Summary Of Favourite Producers</h3>

                                <div className="row">

                                    <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                                        <div className="card h-100">
                                            <div className="content">
                                                <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                <h5>User 1</h5>

                                                <UserModal btnText="View" id={`View1`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                                    <div className='d-flex jc-between ai-center modal_header'>
                                                        <div className='d-flex ai-center'>
                                                            <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                            <div className='mx-3'>
                                                                <h5>User 1</h5>
                                                                <small>100 orders </small>
                                                            </div>
                                                        </div>

                                                        <div className='text-center'>
                                                            <TooltipComponent className="" placement="bottom" tooltipText="Remove from Favourite">
                                                                <span>
                                                                    <AiFillStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                                </span>
                                                            </TooltipComponent>
                                                        </div>
                                                    </div>

                                                    <div className='mb-4'>
                                                        <small>Other details will add according to system and it's data</small>
                                                    </div>
                                                    <div>
                                                        <h6>Terms and conditions</h6>
                                                        <small>No third-party payment. Thank you</small>
                                                    </div>
                                                </UserModal>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                                        <div className="card h-100">
                                            <div className="content">
                                                <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                <h5>User 2</h5>

                                                <UserModal btnText="View" id={`View2`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                                    <div className='d-flex jc-between ai-center modal_header'>
                                                        <div className='d-flex ai-center'>
                                                            <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                            <div className='mx-3'>
                                                                <h5>User 2</h5>
                                                                <small>200 orders </small>
                                                            </div>
                                                        </div>

                                                        <div className='text-center'>
                                                            <TooltipComponent className="" placement="bottom" tooltipText="Add to Favourite">
                                                                <span>
                                                                    <AiOutlineStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                                </span>
                                                            </TooltipComponent>
                                                        </div>
                                                    </div>

                                                    <div className='mb-4'>
                                                        <small>Other details will add according to system and it's data</small>
                                                    </div>
                                                    <div>
                                                        <h6>Terms and conditions</h6>
                                                        <small>No third-party payment. Thank you</small>
                                                    </div>
                                                </UserModal>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                                        <div className="card h-100">
                                            <div className="content">
                                                <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                <h5>User 3</h5>

                                                <UserModal btnText="View" id={`View3`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                                    <div className='d-flex jc-between ai-center modal_header'>
                                                        <div className='d-flex ai-center'>
                                                            <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                            <div className='mx-3'>
                                                                <h5>User 3</h5>
                                                                <small>200 orders </small>
                                                            </div>
                                                        </div>

                                                        <div className='text-center'>
                                                            <TooltipComponent className="" placement="bottom" tooltipText="Add to Favourite">
                                                                <span>
                                                                    <AiOutlineStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                                </span>
                                                            </TooltipComponent>
                                                        </div>
                                                    </div>

                                                    <div className='mb-4'>
                                                        <small>Other details will add according to system and it's data</small>
                                                    </div>
                                                    <div>
                                                        <h6>Terms and conditions</h6>
                                                        <small>No third-party payment. Thank you</small>
                                                    </div>
                                                </UserModal>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-12 mt-4">
                                        <div className="card h-100">
                                            <div className="content">
                                                <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                <h5>User 4</h5>

                                                <UserModal btnText="View" id={`View4`} customClasses="btn_view" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                                    <div className='d-flex jc-between ai-center modal_header'>
                                                        <div className='d-flex ai-center'>
                                                            <img src={defaultUser} alt="image" className='img-fluid' style={{ width: "50px" }} />
                                                            <div className='mx-3'>
                                                                <h5>User 4</h5>
                                                                <small>200 orders </small>
                                                            </div>
                                                        </div>

                                                        <div className='text-center'>
                                                            <TooltipComponent className="" placement="bottom" tooltipText="Add to Favourite">
                                                                <span>
                                                                    <AiOutlineStar style={{ fontSize: "30px", cursor: "pointer", color: "#eeaf43" }} />
                                                                </span>
                                                            </TooltipComponent>
                                                        </div>
                                                    </div>

                                                    <div className='mb-4'>
                                                        <small>Other details will add according to system and it's data</small>
                                                    </div>
                                                    <div>
                                                        <h6>Terms and conditions</h6>
                                                        <small>No third-party payment. Thank you</small>
                                                    </div>
                                                </UserModal>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Marketplace
